import { Dot, Loader2 } from "lucide-react";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import ReactTextTransition from "react-text-transition";
import { useRecoilState } from "recoil";
import io from "socket.io-client";
import { brokerFlagState } from "../Atoms/auth/BrokerFlag";
import {
  formatMoney,
  generateTokenForSocket,
  getAccountBalances,
} from "../helpers/helperFunctions";

import BrokerConnectButton from "./BrokerConnectButton";
import { brokerConnectModalAtom } from "@/Atoms/modal/DialogueAtoms";
import { CURRENT_BROKER_ID } from "@/config/logos";

const Funds = (props: any) => {
  const router = useRouter();
  const { t } = useTranslation("layout");
  const [accountFunds, setAccountFunds] = useRecoilState(brokerFlagState);
  const [index, setIndex] = useState<any>();
  const [change, setChange] = useState<string>("");
  const [showConnectForm, setShowConnectForm] = useRecoilState(
    brokerConnectModalAtom
  );
  useEffect(() => {
    const u = JSON.parse(localStorage.getItem("user-info")!);
    if (!u?.user_id) return;
    getAccountBalances(u, setAccountFunds, CURRENT_BROKER_ID, () => {
      setShowConnectForm(true);
    });
    // const socket = io("https://wss.mktdynamics.com:3222");
    const socket = io("https://wsstest.trylevel2.com:3222", {
      auth: {
        secret: generateTokenForSocket,
      },
    });
    socket.emit("addUserToRoom", u.user.unique_key + ".web.event.funds");
    socket.on("getMessageFromServer", (data) => {
      getAccountBalances(u, setAccountFunds, CURRENT_BROKER_ID);
    });
  }, [accountFunds.isConnected]);

  useEffect(() => {
    if (accountFunds.connectedBrokers.length > 0) {
      setChange(
        (
          ((parseFloat(accountFunds.connectedBrokers[0].amount) -
            parseFloat(accountFunds.connectedBrokers[0].last_equity)) /
            accountFunds.connectedBrokers[0].amount) *
          100
        ).toString()
      );
    }

    let len = accountFunds?.connectedBrokers?.length || 0,
      timeOutId: any;
    if (len) {
      let changeIndex = (_index: number) => {
        setIndex(_index);
        timeOutId = setTimeout(() => {
          changeIndex((_index + 1) % len);
        }, 5000);
      };
      changeIndex(0);
      return () => {
        clearTimeout(timeOutId);
      };
    } else setIndex(NaN);
  }, [accountFunds]);

  const customComponent = (value: any) => {
    let len = accountFunds?.connectedBrokers?.length || 0;
    return len <= 1 ? (
      <div
        title={value}
        className="truncate max-w-[100px] text-[12px] font-semibold"
      >
        {value}
      </div>
    ) : (
      <ReactTextTransition className="big" inline>
        <div
          title={value}
          className="truncate max-w-[100px] text-[12px] font-semibold"
        >
          {value}
        </div>
      </ReactTextTransition>
    );
  };

  return accountFunds.loading ? (
    <div className="cursor-pointer flex justify-center items-center">
      <Loader2 className="ml-2 h-5 w-5 animate-spin" />
    </div>
  ) : isNaN(+index) ? (
    <BrokerConnectButton />
  ) : (
    <div
      className="cursor-pointer flex flex-col gap-2 items-center "
      onClick={() => setShowConnectForm(true)}
    >
      <div className="flex items-center">
        <div className="w-[10px] h-[10px] rounded-xl bg-[--marketplace-green]"></div>
        <div>
          <p className="text-muted-foreground text-xs font-bold  ml-2">
            Broker Connected
          </p>
        </div>
      </div>
      <div className="flex w-full mt-[-5px] font-bold text-xs">
        <p>{t("Balance")}</p>
        <div
          className={`flex ${
            accountFunds.connectedBrokers[index]?.amount > 0
              ? "text-[--marketplace-green]"
              : accountFunds.connectedBrokers[index]?.amount !== 0
              ? "text-[--marketplace-red]"
              : ""
          } gap-1 items-center`}
        >
          <p className="lg:mb-0.5 font-bold ml-2">
            {accountFunds.connectedBrokers[index]?.amount > 0
              ? "+"
              : accountFunds.connectedBrokers[index]?.amount !== 0
              ? ""
              : "-"}
          </p>
          <p className="whitespace-no-wrap w-fit">
            {customComponent(
              (accountFunds.connectedBrokers[index]?.currency == "USD"
                ? "$"
                : accountFunds.connectedBrokers[index]?.currency) +
                formatMoney(
                  +accountFunds.connectedBrokers[index]?.amount || 0,
                  2
                )
            )}
          </p>
        </div>
        {/* <span className="ml-2"></span>
        {parseFloat(change) >= 0 ? (
          <span className="text-xs text-green-foreground">
            {formatMoney(+change || 0, 2)}%
          </span>
        ) : (
          <span className="text-xs text-red-foreground">
            {formatMoney(+change || 0, 2)}%
          </span>
        )} */}
      </div>
    </div>
  );
};

export default Funds;
